import { render, staticRenderFns } from "./admin-allowance.vue?vue&type=template&id=59a7c38e&scoped=true"
import script from "./admin-allowance.vue?vue&type=script&lang=js"
export * from "./admin-allowance.vue?vue&type=script&lang=js"
import style0 from "./admin-allowance.vue?vue&type=style&index=0&id=59a7c38e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a7c38e",
  null
  
)

export default component.exports